import { formatTravellerInfo } from '../Functions'

/** Separatore tra le parti della cella richiedente */
const SEP = ' · '

/**
 * Cella compatta per il richiedente: nome, email, telefono e PID su una sola riga
 * separati da " · ", con ellipsis in caso di overflow.
 * @param {Object} props - Proprietà del componente
 * @param {Object} props.traveller - Oggetto viaggiatore dalla conversazione
 * @returns {JSX.Element} Cella formattata del richiedente
 */
export function TravellerCell({ traveller }) {
  const info = formatTravellerInfo(traveller)

  const parts = [info.fullName]
  if (info.email) parts.push(info.email)
  if (info.phone) parts.push(info.phone)
  if (info.pid) parts.push(`PID: ${info.pid}`)

  return (
    <div className="gigi-traveller-cell" title={parts.join(SEP)}>
      <span className="gigi-traveller-name">{info.fullName}</span>
      {(info.email || info.phone || info.pid) && (
        <>
          <span className="gigi-traveller-sep" aria-hidden>
            {SEP}
          </span>
          <span className="gigi-traveller-detail">
            {[info.email, info.phone, info.pid ? `PID: ${info.pid}` : ''].filter(Boolean).join(SEP)}
          </span>
        </>
      )}
    </div>
  )
}
